<template>
  <div class="comment position-relative">
    <div class="title mb-2">
      <div class="name">{{ $t("common.addComment") }}</div>
    </div>
    <div class="text mb-3">
      <eg-b-form-textarea
        v-model="newCommentText"
        :placeholder="$t('essays.enterFeedback')"
        rows="3"
        max-rows="6"
        class="comment-textarea"
      />
    </div>

    <div class="d-flex mb-2">
      <eg-button
        type="secondary"
        size="small"
        class="ml-auto mr-2"
        @click="$emit('close')"
      >
        {{ $t("common.cancel") }}
      </eg-button>
      <eg-button
        type="primary"
        size="small"
        @click="$emit('save', newCommentText)"
      >
        {{ $t("common.save") }}
      </eg-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopoverAddComment",
  data() {
    return {
      newCommentText: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.comment {
  min-width: 290px;
}

.title {
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: var(--typography-font-family-text-primary);
  font-size: var(--typography-font-size-fs-300);
  font-weight: var(--typography-font-weight-fw-600);
  .name {
    font-weight: 700;
  }
}

.text {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  .comment-textarea {
    border-radius: var(--radius-rd-300);
    border: 1px solid var(--color-stroke-primary-default);
    background: var(--color-components-input-inputBackground);
    padding: 8px;
    font-size: 14px;
    resize: vertical;
    overflow: auto !important;
    &:focus {
      border-color: #6c5ce7;
      box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);
    }
  }
}

// Sticker picker overlay
.sticker-picker-overlay {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  margin-top: 8px;
}

.sticker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  h6 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>
